import React from "react"
import type { ComponentType, SVGProps } from "react"
import { Box, Typography, useTheme } from "@mui/material"
import { fontWeight } from "@/theme/typography"

export const PAYMENT_INLINE_INDICATOR_ICON_SIZE_PX = 16
export const PAYMENT_INLINE_INDICATOR_ICON_SIZE_COMPACT_PX = 14

export type PaymentInlineIndicatorSize = "default" | "compact"

export type PaymentInlineIndicatorProps = {
  label: string
  Icon: ComponentType<SVGProps<SVGSVGElement>>
  accentColor: string
  ariaLabel: string
  className?: string
  size?: PaymentInlineIndicatorSize
}

export function PaymentInlineIndicator({
  label,
  Icon,
  accentColor,
  ariaLabel,
  className,
  size = "default",
}: PaymentInlineIndicatorProps) {
  const theme = useTheme()
  const iconSizePx =
    size === "compact" ? PAYMENT_INLINE_INDICATOR_ICON_SIZE_COMPACT_PX : PAYMENT_INLINE_INDICATOR_ICON_SIZE_PX

  return (
    <Box
      className={className}
      sx={{
        display: "inline-flex",
        alignItems: "center",
        gap: theme.spacing(0.5),
        color: accentColor,
        minWidth: 0,
      }}
      aria-label={ariaLabel}
    >
      <Box
        component="span"
        aria-hidden
        sx={{
          display: "inline-flex",
          flexShrink: 0,
          alignItems: "center",
          justifyContent: "center",
          lineHeight: 0,
          "& svg": {
            width: iconSizePx,
            height: iconSizePx,
            display: "block",
          },
        }}
      >
        <Icon />
      </Box>
      <Typography
        component="span"
        variant="body2"
        sx={{
          fontWeight: fontWeight.semibold,
          color: "inherit",
          lineHeight: 1.35,
          ...(size === "compact" ? { fontSize: theme.typography.pxToRem(12) } : {}),
        }}
      >
        {label}
      </Typography>
    </Box>
  )
}

export default PaymentInlineIndicator
